//@flow

export * from './GA-4';

export type ScriptOptions = {
  async?: boolean,
  defer?: boolean,
  crossorigin?: 'anonymous' | 'use-credentials',

  attributes?: {[key: string]: string},
};

export function loadScript(src: string, options: ScriptOptions) {
  const script = document.createElement('script');

  script.src = src;
  script.async = !!options.async;
  script.defer = !!options.defer;
  script.crossOrigin = options.crossorigin;

  const {attributes} = options;
  if (attributes) {
    Object.keys(attributes).forEach((key: string) => {
      script.setAttribute(key, attributes[key]);
    });
  }

  if (document.body) document.body.appendChild(script);
}
